var _process, _process$env;

import Grid from './Grid';
export default (_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.NODE_ENV && process.env.NODE_ENV === 'production' ? function (_ref) {
  var children = _ref.children;
  return children;
} : Grid;
//# sourceMappingURL=index.js.map